/* eslint-disable camelcase */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
    maxWidth: 650,
  },
  list: {
    fontSize: 12,
  },
  unorderedList: {
    listStyleType: 'disc',
    paddingLeft: 20,
  },
}));

const Scripts = () => {
  const classes = useStyles();
  return (
    <div>
      <h4 className={classes.title}> Follow the instructions below and click CONTINUE.</h4>
      <ol className={classes.list}>
        <li> Open “Neuralert-Wifi-Script.ttl” using any text editor.</li>
        <ul className={classes.unorderedList}>
          <li>Change “ssid” in line 16 to the name of the wifi network</li>
          <li>Change “device id” in line 28 to the monitor's 6-character id</li>
          <li>Change “device password” in line 31 to the password for the monitor</li>
          <li>
            Save the modified script as “Neuralert-Wifi-Script-&lt;device id&gt;.ttl” where &lt;device id&gt; is the
            monitor id used above
          </li>
        </ul>
        <li>Open “Neuralert-MQTT-script.ttl” using any text editor.</li>
        <ul className={classes.unorderedList}>
          <li>
            In line 25, update “Neuralert-&lt;device id&gt;” where &lt;device id&gt; is the
            monitor id used in the wifi script above
          </li>
          <li>
            In line 28, update “Neuralert-Publish/&lt;device id&gt;” where &lt;device id&gt; is the
            monitor id used in the wifi script above
          </li>
          <li>
            Save the modified script as “Neuralert-MQTT-script-&lt;device id&gt;.ttl” where &lt;device id&gt; is the
            monitor id used above
          </li>
        </ul>
      </ol>
    </div>
  );
};

export default Scripts;
